import { useContext } from 'react';
import AnimatedCount from './AnimatedCount';
import { LanguageContext } from '~/helpers/LanguageContext';
import { CTAIconPosition, CTATag } from '../../atoms/CTA/CTA.constants';
import {
  ResultNumber,
  ResultText,
  SearchFlagsBody,
  SearchFlagsHeader,
  StyledCTA,
  StyledFilterFlag,
  Wrapper,
} from './SearchFlags.styles';
import { useIntl } from 'react-intl';

/**
 * @param {SearchFlagsProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SearchFlags = ({ resultsAmount, activeFlags, handleReset }) => {
  const intl = useIntl();
  const lang = useContext(LanguageContext);
  const jobsCounter =
    typeof window !== 'undefined' && document.getElementById('animatedCount');
  return (
    <Wrapper data-id="search-flags-wrapper">
      <SearchFlagsHeader data-id="search-flags-header">
        <ResultText data-id="search-flags-result-text">
          {resultsAmount > 0 && (
            <ResultNumber data-id="search-flags-result-number">
              <AnimatedCount
                count={resultsAmount}
                domID={'animatedCount'}
                lang={lang}
                data-id="search-flags-result-number-animated-count"
              >
                <>
                  <span id="animatedCount">
                    {jobsCounter ? jobsCounter.innerHTML : '0'}
                  </span>
                </>
              </AnimatedCount>
            </ResultNumber>
          )}
          {resultsAmount > 0
            ? intl.formatMessage(
                { id: 'jobFilterText' },
                { amount: resultsAmount },
              )
            : intl.formatMessage({
                id: 'jobFilterNoResults.text',
              })}
        </ResultText>
      </SearchFlagsHeader>
      {activeFlags.length > 0 && (
        <SearchFlagsBody data-id="search-flags-body">
          {activeFlags.map((flagProps) => (
            <StyledFilterFlag
              {...flagProps}
              handleReset={(value) =>
                activeFlags.length === 1
                  ? handleReset('resetAllFilters')
                  : handleReset(value)
              }
              key={flagProps.id}
            />
          ))}
          <StyledCTA
            title={intl.formatMessage({
              id: 'jobFilter.resetAll',
            })}
            text={intl.formatMessage({
              id: 'jobFilter.resetAll',
            })}
            type={CTATag.Button}
            icon="ARROW_ANIMATION"
            iconPos={CTAIconPosition.Before}
            skin="TERTIARY"
            handleBtnClick={() => handleReset('resetAllFilters')}
          />
        </SearchFlagsBody>
      )}
    </Wrapper>
  );
};

export default SearchFlags;
